import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTev2MonthlySongListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTev2MonthlySongListQuery = { __typename?: 'Query', tev2MonthlySongList: Array<{ __typename?: 'Tev2MonthlySongInfo', seq?: number | null, year: number, month: number, tev2Banner: string, introductionBanner: string, vimeoId: string, tev2SongId: string }> };


export const GetTev2MonthlySongListDocument = gql`
    query getTev2MonthlySongList {
  tev2MonthlySongList {
    seq
    year
    month
    tev2Banner @wf_blobSignature(name: "TEV2_TE_BANNERS_SIGNATURE")
    introductionBanner @wf_blobSignature(name: "TEV2_TE_BANNERS_SIGNATURE")
    vimeoId
    tev2SongId
  }
}
    `;

/**
 * __useGetTev2MonthlySongListQuery__
 *
 * To run a query within a React component, call `useGetTev2MonthlySongListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTev2MonthlySongListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTev2MonthlySongListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTev2MonthlySongListQuery(baseOptions?: Apollo.QueryHookOptions<GetTev2MonthlySongListQuery, GetTev2MonthlySongListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTev2MonthlySongListQuery, GetTev2MonthlySongListQueryVariables>(GetTev2MonthlySongListDocument, options);
      }
export function useGetTev2MonthlySongListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTev2MonthlySongListQuery, GetTev2MonthlySongListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTev2MonthlySongListQuery, GetTev2MonthlySongListQueryVariables>(GetTev2MonthlySongListDocument, options);
        }
export type GetTev2MonthlySongListQueryHookResult = ReturnType<typeof useGetTev2MonthlySongListQuery>;
export type GetTev2MonthlySongListLazyQueryHookResult = ReturnType<typeof useGetTev2MonthlySongListLazyQuery>;
export type GetTev2MonthlySongListQueryResult = Apollo.QueryResult<GetTev2MonthlySongListQuery, GetTev2MonthlySongListQueryVariables>;